import styles from './StoreLaunch.module.css';

const LaunchPopup = ({ onClose }) => {
    return (
        <div className={styles.popupOverlay}>
            <div className={styles.popup}>
                <button className={styles.closeButton} onClick={onClose}>×</button>
                <h2 className={styles.title}>🎉 Grand Opening Alert!</h2>
                <p className={styles.message}>
                  We're excited to announce the grand opening of <br />
                  our new store in <strong className={styles.location}> Anna Nagar, Chennai </strong> <br />
                </p>
                <button className={styles.ctaButton} onClick={onClose}>Explore Now 🚀</button>
            </div>
        </div>
    );
};

export default LaunchPopup;
